import { ArrowRight, BriefcaseBusiness, Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { WorkEnvironment } from '@/lib/environmentChoice';

export function EnvironmentCards({ onChoose, networkName }: { onChoose: (environment: WorkEnvironment) => void; networkName: string }) {
  return (
    <div className="grid w-full gap-4 sm:grid-cols-2">
      {([
        { id: 'team', prefix: 'Entrar na', title: networkName, Icon: Building2 },
        { id: 'broker', prefix: 'Área do', title: 'Corretor', Icon: BriefcaseBusiness },
      ] as const).map(({ id, prefix, title, Icon }) => (
        <Button key={id} variant="outline" onClick={() => onChoose(id)}
          className="group h-auto min-h-48 w-full flex-col items-start justify-between gap-8 whitespace-normal rounded-lg bg-card p-6 text-left normal-case tracking-normal hover:border-primary sm:min-h-56">
          <Icon className="!h-9 !w-9 text-primary" aria-hidden="true" />
          <span className="flex w-full items-center justify-between gap-4">
            <span className="min-w-0 break-words text-xl font-normal text-foreground">{prefix} <strong className="font-bold">{title}</strong></span>
            <ArrowRight className="shrink-0 text-muted-foreground group-hover:text-primary" aria-hidden="true" />
          </span>
        </Button>
      ))}
    </div>
  );
}